// src/pages/ShopPage.js
import React from "react";
import { Link } from "react-router-dom";
import "./SimplePage.css";

export default function ShopPage() {
  return (
    <div className="simple-page">
      <div className="section" style={{paddingTop:"8rem", textAlign:"center"}}>
        <span className="section-eyebrow">商店 · Le Shop</span>
        <h1 className="section-title">Bientôt</h1>
        <div className="divider divider-center"/>
        <p style={{color:"var(--ash)", maxWidth:"500px", margin:"0 auto 2rem", lineHeight:2, fontSize:"0.85rem"}}>
          Le shop Takkyu Oni arrive. T-shirts, stickers, et merch custom générés depuis ton avatar démoniaque.
          Lié à Printify pour une production à la demande.
        </p>
        <div style={{display:"flex", gap:"1rem", justifyContent:"center", flexWrap:"wrap"}}>
          <Link to="/awaken" className="btn btn-primary">CRÉER MON DÉMON D'ABORD →</Link>
        </div>
        <div className="coming-soon-items">
          {["T-SHIRT ONI · 29€","STICKER PACK · 12€","HOODIE DÉMON · 59€","POSTER FORMAT A2 · 19€"].map(item => (
            <div key={item} className="coming-item">
              <div className="coming-thumb">?</div>
              <p>{item}</p>
              <span className="badge badge-ghost">BIENTÔT</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
